import { formatUserName } from '@witmetrics/utils/strings';
import type { UndecoratedUser } from '@witmetrics/utils';
import ProfilePicture from '@/components/ProfilePicture';
import { classes } from './utils';

export type AssignedToProps = {
  assignedTo: UndecoratedUser;
};

export default function AssignedTo({ assignedTo }: AssignedToProps) {
  return (
    <div className={classes.list}>
      <ProfilePicture
        className={classes.profilePicture}
        size={30}
        user={assignedTo}
      />
      <span className={classes.assignedTo}>{formatUserName(assignedTo)}</span>
    </div>
  );
}
